export const rankDashboardBase = () =>
    process.env.RUNTIME_ENV === "production"
        ? "https://cleaning-rank-dashboard-829912128848.asia-northeast1.run.app"
        : "https://cleaning-rank-dashboard-dev-829912128848.asia-northeast1.run.app"

// workerId はパスセグメントとしてエンコードする。
// 通常は JWT 由来の UUID でエンコード前後とも同じ文字列になるが、
// ランクダッシュボード側の /dashboard/[workerId] は UUID でない場合に
// 氏名として検索する実装のため、日本語や予約文字を渡しても壊れないようにしておく。
export const rankDashboardUrl = (workerId: string): string =>
    `${rankDashboardBase()}/dashboard/${encodeURIComponent(workerId)}`

export const rankDashboardApiUrl = (workerId: string): string =>
    `${rankDashboardBase()}/api/preview/${encodeURIComponent(workerId)}`

/**
 * インセンティブプログラム対象者かどうかの判定API。
 * ランクダッシュボードへの導線を出すかどうかの判定に使う。
 * 200 { isTarget: boolean } を返し、BQ 障害時は 503。
 */
export const incentiveTargetApiUrl = (workerId: string): string =>
    `${rankDashboardBase()}/api/incentive-target/${encodeURIComponent(workerId)}`

export const sumycaDomain = () => {
    return process.env.RUNTIME_ENV === "production"
        ? "https://sumyca.com"
        : "https://matsuri-tech-sumyca-front-dev.vercel.app"
}

export function openUrlInNewTab(url: string): void {
    window.open(url, "_blank", "noopener,noreferrer")
}

export function sumycaListingUrl(listingId: string): string {
    return `${sumycaDomain()}/listings/${listingId}?utm_source=cleaner_front`
}

// Maps URLs (API Key 不要)。アプリが入っていれば Google Map アプリで開く
export function googleMapSearchUrl(address: string): string {
    return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(address)}`
}
